import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { IContact } from 'app/interfaces/contact.interface';
import { environment } from 'environments/environment';
import { MemedService } from 'modules/promptuary/services/memed/memed.service';

@Component({
	selector: 'memed-integration',
	templateUrl: './memed-integration.component.html',
	styleUrls: ['./memed-integration.component.scss'],
})
export class MemedIntegration implements OnInit, OnDestroy {
	dataError: boolean;
	memed = {
		modal: 0,
		message: '',
		loaded: false,
	};

	@Input() memedElemScriptId: string;
	@Input() contact: IContact;
	@Input() appointmentId: string;
	@Input() clientId: string;
	@Output() back = new EventEmitter<any>();
	showCreateMemedUserModal = false;
	constructor(private memedService: MemedService) {}

	@Input()
	public set visible(visible: boolean) {
		if (visible) {
			this.checkCredentials(true);
		}
	}

	ngOnInit() {
		const memedScript = document.getElementById(this.memedElemScriptId || '');
		memedScript ? (this.memed.loaded = true) : this.checkCredentials(true);
	}

	checkCredentials(showModal = false) {
		this.memedService.getToken().subscribe(
			({ token }) => {
				this.injectMemedScript(token);
			},
			() => {
				this.showCreateMemedUserModal = showModal;
			}
		);
	}

	onCloseCreateMemedUserModal() {
		this.showCreateMemedUserModal = false;
		this.back.emit();
	}

	onCreateMemedUser() {
		this.checkCredentials(true);
		this.showCreateMemedUserModal = false;
	}

	injectMemedScript(token) {
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.id = this.memedElemScriptId;
		script.src = environment.memedIntegration.scriptUrl;
		script.dataset['token'] = token;
		script.dataset['container'] = 'memedContainer';
		document.head.appendChild(script);
		script.onload = () => {
			this.initializeMemedModule();
		};
	}

	initializeMemedModule() {
		window['MdSinapsePrescricao'].event.add('core:moduleInit', (module) => {
			if (module.name === 'plataforma.prescricao') {
				this.memed.loaded = true;
				const mdHub = window['MdHub'];

				mdHub.command.send('plataforma.prescricao', 'setFeatureToggle', {
					deletePatient: false,
					removePatient: false,
					editPatient: false,
					guidesOnboarding: false,
					buttonClose: false,
					dropdownSync: false,
				});

				mdHub.command.send('plataforma.prescricao', 'setPaciente', {
					idExterno: this.contact.id,
					nome: this.contact.displayName,
					cpf: this.contact.fiscalId,
					telefone: this.contact.phoneMobile,
				});

				window['MdHub'].module.show('plataforma.prescricao');

				mdHub.event.add('prescricaoImpressa', (prescriptionData) => {
					// No objeto "prescriptionData", é retornado as informações da prescrição gerada.
					if (prescriptionData?.prescricao?.id) {
						this.registerDocumentPrescription({
							customerId: this.clientId,
							eventId: this.appointmentId,
							prescriptionId: prescriptionData.prescricao.id,
						});
					}
				});
			}
		});
	}

	ngOnDestroy() {
		const memedScript = document.getElementById(this.memedElemScriptId || '');

		if (memedScript) {
			memedScript.remove();
		}
	}

	registerDocumentPrescription(data: {
		prescriptionId: number;
		customerId: string;
		eventId: string;
	}) {
		this.memedService
			.registerDocumentPrescription({
				...data,
				prescriptionId: String(data.prescriptionId),
			})
			.subscribe();
	}
}
